/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 3/4/2023
 */

import { Delete, Edit, ExpandLess, ExpandMore } from "@mui/icons-material";
import {
  ButtonGroup,
  Collapse,
  Container,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useGetAllCatWithSubCatQuery } from "../../Store/Services/CategoryService";
import {
  openDeleteCategoryModal,
  openEditCategoryModal,
} from "../../Store/Slices/categorySlice";

import styles from "./NestedTable.module.css";

const NestedTable = () => {
  const { data: categories, isSuccess } = useGetAllCatWithSubCatQuery();

  let catList;
  if (isSuccess) {
    catList = categories;
  }

  const level = 1;

  return (
    <>
      <Container>
        <TableContainer>
          <Table className={styles.tableContainer} size="small">
            <TableBody>
              {catList?.map((cat) => (
                <RenderSubNode key={cat.catId} nodes={cat} level={level} />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>
    </>
  );
};

const RenderSubNode = (props) => {
  const { nodes } = props;
  const { level } = props;
  const [expand, setExpand] = useState(false);

  const dispatch = useDispatch();

  let space = 30 * level;

  const roles = sessionStorage.getItem("roles");

  return (
    <>
      <TableRow className={styles.tRow}>
        {nodes.subCategories &&
        Array.isArray(nodes.subCategories) &&
        nodes.subCategories.length !== 0 ? (
          <TableCell
            style={{
              paddingLeft: `${space}px`,
              borderBottom: "none",
              verticalAlign: "middle", 
              marginTop:"5px"
            }}
          >
            <IconButton onClick={() => setExpand(!expand)}>
              {expand ? <ExpandLess /> : <ExpandMore />}
            </IconButton>
            {nodes.catDisplay}
          </TableCell>
        ) : (
          <TableCell
            style={{
              paddingLeft: `${space + 40}px`,
              borderBottom: "none",
              verticalAlign: "middle", 
              marginTop:"10px"
            }}
          >
            {nodes.catDisplay}
          </TableCell>
        )}
        <TableCell
          style={{
            paddingLeft: `${400 - space}px`,
            verticalAlign: "middle", 
          }}
          className={styles.tCell}
        >
          <ButtonGroup>
            {roles?.split(",").includes("PRIV_ES_EDIT_CATEGORY") ?  (<IconButton
              onClick={() => {
                dispatch(openEditCategoryModal(nodes.catId));
              }}
            >
              <Edit />
            </IconButton>) : null}
            {roles?.split(",").includes("PRIV_ES_DELETE_CATEGORY") ? (<IconButton
              onClick={() => {
                dispatch(openDeleteCategoryModal(nodes.catId));
              }}
            >
              <Delete />
            </IconButton>) : null}
          </ButtonGroup>
        </TableCell>
      </TableRow>
      <hr className={styles.line} />
      <Collapse in={expand} timeout="auto" unmountOnExit>
        {nodes.subCategories && Array.isArray(nodes.subCategories)
          ? nodes.subCategories.map((node) => (
              <RenderSubNode key={node.catId} nodes={node} level={level + 1} />
            ))
          : null}
      </Collapse>
    </>
  );
};

export default NestedTable;